import request from '../utils/request';

/**
 * 获取用户额度账户分页列表
 * @param {Object} params - 查询参数
 * @returns {Promise} - 返回请求结果
 */
export function getUserQuotaAccountList(params) {
  return request({
    url: '/user-quota-accounts/list',
    method: 'get',
    params
  });
} 